import React, { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import ShopList from "../Components/Sub-Components/ShopList";
import ShopSidebar from "../Components/ShopSidebar";
import envConstants from "../Constants";
import axios from "../Axiosapi";
import { Helmet } from "react-helmet-async";

const Shop = () => {
    const [categories, setCategories] = useState([]);
    const [products, setProducts] = useState([]);
    const [brands, setBrands] = useState([]);
    const [nextPage, setNextPage] = useState();
    const [previousPage, setPreviousPage] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState();
    const [loadingCategories, setLoadingCategories] = useState(true);
    const [loadingBrands, setLoadingBrands] = useState(true);
    const [loadingProducts, setLoadingProducts] = useState(true);
    const [errorCategories, setErrorCategories] = useState(null);
    const [errorProducts, setErrorProducts] = useState(null);
    const [errorBrands, setErrorBrands] = useState(null);
    const [meta, setMeta] = useState();
    const [isReadMore, setIsReadMore] = useState(false);

    const location = useLocation();


    const fetchProducts = useCallback(async (category = null, child_category = null, page = 1, brand = null, pagination = 20, json = false) => {
        setLoadingProducts(true);
        try {
            let url = `${envConstants.API_BASE_URL}/shop?page=${page}`;
            if (category) {
                url += `&category=${category}`;
            }
            if (child_category) {
                url += `&child_category=${child_category}`;
            }
            if (brand) {
                url += `&brand=${brand}`;
            }

            const response = await axios.get(url, {
                params: {
                    pagination: pagination,
                },
                responseType: json ? 'json' : 'json',
            });
            setMeta(response.data.meta);
            setProducts(response.data.data);
            setTotalCount(response.data.total);
            setTotalPages(response.data.last_page);
            setNextPage(page < response.data.last_page ? parseInt(page) + 1 : 1);
            setPreviousPage(page > 1 ? page - 1 : 1);
            setCurrentPage(page);
            setErrorProducts(null); // Reset error state
        } catch (error) {
            setErrorProducts(error);
            console.error(error);
        } finally {
            setLoadingProducts(false);
        }
    }, []);

    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const category = query.get('category');
        const child_category = query.get('child_category');
        const page = query.get('page');
        const brand = query.get('brand');

        //fetchCategories();
        //fetchBrands();
        fetchProducts(category, child_category, page, brand);
    }, [location.search]);

    const canonicalUrl = window.location.href ? window.location.href  || 'https://autopartstation.com.au/' : 'https://autopartstation.com.au/';
    const seotitle = meta ? meta.find(item => item.option === '_seo_title')?.value || 'Auto Parts & Accessories - Quality Products at Great Prices' : 'Auto Parts & Accessories - Quality Products at Great Prices';
    const seodescription = meta ? meta.find(item => item.option === '_seo_description')?.value || 'Auto Part Station shop' : 'Auto Part Station shop';
    const seotags = meta ? meta.find(item => item.option === '_seo_tags')?.value || 'Auto Part Station tool shop, Auto Part Station store, Auto Part Station australia' : 'Auto Part Station tool shop, Auto Part Station store, Auto Part Station australia';
    const description = meta ? meta.find(item => item.option === '_description')?.value || '' : '';
    const image = meta ? meta.find(item => item.option === '_editor_image')?.value || '' : '';
    const index = meta ? meta.find(item => item.option == '_page_index')?.value : '1';


    let schemaMarkup;

    if (meta) {
        const schemaString = meta.find(item => item.option === '_schema_markup')?.value;
        if (schemaString) {
            try {
                schemaMarkup = JSON.parse(schemaString);
            } catch (e) {
                // If parsing fails, fallback to default schema
                schemaMarkup = {
                    "@context": "https://schema.org",
                    "@type": "WebPage",
                    "name": "Shop - Auto Part Station",
                    "url": "https://autopartstation.com.au/shop",
                    "mainEntity": {
                        "@type": "Organization",
                        "name": "Auto Part Station Pty Ltd",
                        "url": "https://autopartstation.com.au",
                        "logo": "https://autopartstation.com.au/auto-part.png"
                    }
                };
            }
        } else {
            schemaMarkup = {
                "@context": "https://schema.org",
                "@type": "WebPage",
                "name": "Shop - Auto Part Station",
                "url": "https://autopartstation.com.au/shop",
                "mainEntity": {
                    "@type": "Organization",
                    "name": "Auto Part Station Pty Ltd",
                    "url": "https://autopartstation.com.au",
                    "logo": "https://autopartstation.com.au/auto-part.png"
                }
            };
        }
    } else {
        schemaMarkup = {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Shop - Auto Part Station",
            "url": "https://autopartstation.com.au/shop",
            "mainEntity": {
                "@type": "Organization",
                "name": "Auto Part Station Pty Ltd",
                "url": "https://autopartstation.com.au",
                "logo": "https://autopartstation.com.au/auto-part.png"
            }
        };
    }

    const handleReadMore = () => {
        setIsReadMore(!isReadMore);
    };

    const stripHtml = (html) => {
        const tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
    };

    const truncateDescription = (htmlContent, maxLength) => {
        const plainText = stripHtml(htmlContent);
        if (plainText.length <= maxLength) return htmlContent;
        
        // Find the last space before maxLength to avoid cutting words
        const lastSpace = plainText.lastIndexOf(' ', maxLength);
        const truncateAt = lastSpace > 0 ? lastSpace : maxLength;
        
        const tmp = document.createElement("DIV");
        tmp.innerHTML = htmlContent;
        let currentLength = 0;
        let truncatedHtml = '';
        
        function processNode(node) {
            if (currentLength >= truncateAt) return false;
            
            if (node.nodeType === 3) { // Text node
                const remainingLength = truncateAt - currentLength;
                const text = node.textContent;
                if (currentLength + text.length <= truncateAt) {
                    truncatedHtml += text;
                    currentLength += text.length;
                } else {
                    truncatedHtml += text.slice(0, remainingLength);
                    currentLength = truncateAt;
                    return false;
                }
            } else if (node.nodeType === 1) { // Element node
                truncatedHtml += `<${node.tagName.toLowerCase()}>`;
                for (const childNode of node.childNodes) {
                    if (processNode(childNode) === false) {
                        truncatedHtml += `</${node.tagName.toLowerCase()}>`;
                        return false;
                    }
                }
                truncatedHtml += `</${node.tagName.toLowerCase()}>`;
            }
            return true;
        }
        
        for (const childNode of tmp.childNodes) {
            if (processNode(childNode) === false) break;
        }
        
        return truncatedHtml + '...';
    };


    return (
        <div className="container p-0 p-sm-2 my-5">
            <Helmet>
                <title>{seotitle}</title>
                <meta name="description" content={seodescription} />
                <meta name="author" content={'Shop a wide range of auto parts and accessories. Enjoy fast shipping and quality products. Join now for exclusive discounts!'} />
                <meta name="keywords" content={seotags} />
                <meta name="robots" content={index == 0 || index == '0' ? 'noindex, nofollow' : 'index, follow'} />
                <link rel="canonical" href={canonicalUrl} />
                <script type="application/ld+json">
                    {JSON.stringify(schemaMarkup)}
                </script>
            </Helmet>
            <div className="shop-section justify-content-between">
                <div className="shop-sidebar d-none">
                    {loadingCategories && loadingBrands ? (
                        <div className="d-flex justify-content-center align-items-center p-5">
                            <div className="spinner-border spinner-border-sm" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : errorCategories ? (
                        <div className="d-flex justify-content-center">
                            Error loading categories and brands: {errorCategories?.message || "Unknown error"} <br />
                            {errorBrands?.message || "Unknown error"}
                        </div>
                    ) : (
                        <ShopSidebar categories={categories} brands={brands} />
                    )}
                </div>
                <div className="shop-list w-100">
                    {loadingProducts ? (
                        <div className="d-flex justify-content-center align-items-center p-5">
                            <div className="spinner-border spinner-border-sm" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : errorProducts ? (
                        <div className="d-flex justify-content-center">Error loading products: {errorProducts.message}</div>
                    ) : (
                        <ShopList
                            products={products}
                            categories={categories}
                            brands={brands}
                            badge=""
                            nextPage={nextPage}
                            previousPage={previousPage}
                            currentPage={currentPage}
                            totalPages={totalPages}
                            totalCount={totalCount}
                            brand={new URLSearchParams(location.search).get('brand')}
                            child_category={new URLSearchParams(location.search).get('child_category')}
                        />
                    )}
                </div>
            </div>
            {description && description.trim() !== '' && (
                <div className="mt-5 px-md-0 px-3 home-content">
                    <div
                        dangerouslySetInnerHTML={{
                            __html: isReadMore ? description : truncateDescription(description, 300),
                        }}
                    />
                    <div className="d-flex justify-content-end">
                        <button
                            onClick={handleReadMore}
                            className="read-more"
                        >
                            {isReadMore ? 'Read Less' : 'Read More'}
                        </button>
                    </div>
                </div>
            )}
            {image && image.trim() !== '' && (
                <div>
                    <img
                        src={`${envConstants.API_BASE_PUBLIC_URL}${image}`}
                        alt="Brand Editor"
                        style={{ width: '100%', height: 'auto' }}
                    />
                </div>
            )}
        </div>
    );
};

export default Shop;